module.exports = __webpack_public_path__ + "img/雷阵雨并伴有冰雹.3edcf131.png";